module.exports = __webpack_public_path__ + "img/fawaterak.10feaa93.svg";